export const getPrior = (func) => (state) => {
  const prior = state?.temp?.priorState?.state;
  if (prior == null) {
    return prior;
  }
  return func(prior);
};
